<div class="column-layout view-document-dialog" #wrapper>
  <div
    mat-dialog-title
    #title
    style="
      display: flex;
      justify-content: stretch;
      width: 100%;
      padding: 0.5rem 1.5rem 1rem 1.5rem;
    "
  >
    <div class="dialog-top-title">Dokumentbetrachter</div>
    <div>
      <app-document-paginator
        [data]="documentInfo"
        [page]="currentPageIdx"
        (pagechanged)="loadPage($event)"
      >
      </app-document-paginator>
    </div>
  </div>

  <mat-dialog-content
    class="mat-typography"
    style="flex: 1; padding-bottom: 8px"
    #cnt
  >
    <div *ngIf="isLoading" class="document-progress-bar-placeholder"></div>
    <div
      *ngIf="isLoading || imageLoading"
      class="document-progress-bar-wrapper"
    >
      <app-document-progress-bar
        [text]="imageLoading ? loadingPageTxt : loadingDataTxt"
      ></app-document-progress-bar>
    </div>
    <div
      id="mcinnercontent"
      class="row-layout view-document-dialog-inner-content"
    >
      <div *ngIf="imageLoadFailed" style="color: red; font-size: 1.5rem">
        Das Bild konnte nicht geladen werden.
      </div>
      <div *ngIf="isPdf">
        <!--
        <img *ngIf="!imgUrl" #docImg />
        -->
        <img
          *ngIf="imgUrl"
          [src]="imgUrl"
          [ngStyle]="currentPageStyle"
          (load)="imageLoaded($event)"
          (error)="imageLoadError($event)"
        />
      </div>
      <div *ngIf="isImageDoc" class="max-size-100">
        <img
          *ngIf="imgUrl"
          [src]="imgUrl"
          #imageview
          class="hidden"
          (load)="imageLoaded($event)"
          (error)="imageLoadError($event)"
        />
      </div>

      <video
        *ngIf="isVideo"
        [attr.type]="videoType"
        [attr.src]="videoSrc"
        playsinline
        controls
        #vs
        style="max-width: 100%; max-height: 100%"
      ></video>
    </div>
  </mat-dialog-content>
  <div
    mat-dialog-actions
    #actions
    class="row-layout pdf-dialog-actions"
    style="margin: 4px 0 0 0; padding: 1rem; width: 100%"
    [ngClass]="
      (isImageDoc && scale < 100) || buttons.length
        ? 'flex-content-space-between'
        : 'flex-content-end'
    "
  >
    <div *ngIf="isImageDoc && scale < 100" style="margin-right: 1rem">
      <div style="display: inline-block; margin-right: 1rem">Zoom:</div>

      <button
        mat-button
        class="view-btn"
        style="margin-right: 1rem"
        [ngClass]="{
          'btn-selected': zoomMode === 1
        }"
        (click)="setZoomMode(1)"
      >
        Anpassen
      </button>
      <button
        mat-button
        class="view-btn"
        [ngClass]="{
          'btn-selected': zoomMode === 2
        }"
        (click)="setZoomMode(2)"
      >
        100%
      </button>
    </div>
    <div *ngIf="buttons.length">
      <ng-container *ngFor="let p of buttons">
        <button mat-button class="document-select" (click)="viewPage(p.page)">
          {{ p.name }}
        </button>
      </ng-container>
    </div>

    <button mat-button class="document-cancel" (click)="close()">
      Schließen
    </button>
  </div>
</div>
